<app-website-header></app-website-header>

<div class="job-details-container p-4">
    <button mat-raised-button style="cursor: pointer;" (click)="onBack()"><mat-icon>arrow_back</mat-icon>Back to all jobs</button>
    <div style="height: 280px; overflow: hidden; margin-top: 1rem;" class="imgContainer">
        <img [src]="jobPost?.image" alt="featured-image" style="width: 100%;max-height:15rem; object-fit: cover">
    </div>
    <section class="job-details-section mb-5 mt-4">
        <div class="row">
            <div class="col-md-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <div class="title-container">
                        <div>
                            <img *ngIf="!jobPost?.postAnonymously && jobPost?.companyLogo" src="{{jobPost?.companyLogo}}" alt="company logo" class="company-logo">
                            <img *ngIf="jobPost?.postAnonymously || jobPost?.companyLogo === null" src='/assets/images/companydefault-logo.svg' alt="logo" class="company-logo">
                        </div>
                        <div style="float:right;">
                            <img src="{{ !isJobSaved ?'/assets/images/careers-apply-icon.svg':'/assets/images/saved-jobs.svg'}}" style="cursor: pointer;" alt="apply-icon"
                                (click)="onSaveJob(jobPost)">
                        </div></div>
                        <div class="mt-2" style="float:left;">
                            <h2>{{jobPost?.title}}</h2>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="job-description-container">
                            <div class="title">Job Description</div>
                            <div class="description jobDescription mt-2" [innerHTML]="jobPost?.description"></div>
                        </div>
                        <div *ngIf="jobPost?.jobDetails" class="job-details-container">
                            <div class="title">Job Details</div>
                            <div class="description companyDetailsDescription mt-2" [innerHTML]="jobPost?.jobDetails"></div>
                        </div>
                        <div *ngIf="!companyDetailsHide" class="job-details-container">
                            <div class="title">About {{jobPost?.company}}</div>
                            <div class="description companyDetailsDescription mt-2" [innerHTML]="jobPost?.content"></div>
                        </div>
                        <div *ngIf="!companyDetailsHide">
                            <div class="address-container">
                              <div class="title">Address</div>
                              <div class="description mt-2">
                                <img src="/assets/images/careers-address-icon.svg" alt="careers-address-icon">
                                {{jobPost?.address}}
                              </div>
                            </div>
                        </div>
                        <ng-container *ngIf="!isApplicationClosed(jobPost?.applicationCloseDate); else closed">
                            <button type="button" class="button button-primary w-auto apply-button"
                                    (click)="onApplyJob(jobPost?.id)">
                              <img src="/assets/images/angle-arrow-small-right.svg" alt="angle-arrow-small-right">
                              Apply Now
                            </button>
                          </ng-container>
                          <ng-template #closed>
                              <div class="application-closed">
                                  <img src="/assets/images/application-closed.svg" alt="application-closed">
                                  <span>Applications Closed</span>
                                </div>
                            </ng-template>
                            <ng-container >
                              <button type="button" class="button shareBtn_button w-auto apply-button"
                                      (click)="onShareJob()">
                                <img src="/assets/images/icons/shareIcon.svg" alt="angle-arrow-small-right" class="shareArrow">
                                Share Now
                              </button>
                            </ng-container>                       
                        </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card mb-3">
                    <div class="card-body application-dates">
                        <div class="date-item">
                            <img src="/assets/images/application-start.svg" alt="Start Icon" class="date-icon">
                            <div>
                                <div class="date-text">Applications Starts</div>
                                <div class="date-value">{{jobPost?.applicationStartDate | date:'dd/MM/YYYY'}}</div>
                            </div>
                        </div>
                        <div class="separator"></div>
                        <div class="date-item">
                            <img src="/assets/images/application-end.svg" alt="End Icon" class="date-icon">
                            <div>
                                <div class="date-text">Applications Ends</div>
                                <div class="date-value">{{jobPost?.applicationCloseDate | date:'dd/MM/YYYY'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="job-categories-section">
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-category.svg" alt="Job Category">
                                </div>
                                <p>Job Category<br><strong>{{jobPost?.category}}</strong></p>
                            </div>
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-type.svg" alt="Job Type"></div>
                                <p>Job Type<br><strong>{{jobPost?.jobType}}</strong></p>
                            </div>
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-level.svg" alt="Level"></div>
                                <p>Level<br><strong>{{jobPost?.careerLevel}}</strong></p>
                            </div>
                        </div>
                        <div class="job-categories-section">
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-experience.svg" alt="Experience">
                                </div>
                                <p>Experience<br><strong>{{jobPost?.experienceFrom}} - {{jobPost?.experienceTo}} years</strong></p>
                            </div>
                            <div class="mb-4" *ngIf="!salaryHide">
                                <div class="icon"><img src="/assets/images/careers-job-salary.svg" alt="Salary"></div>
                                <p>Salary<br>
                                  <strong>{{getCurrencySymbol(jobPost?.salaryCurrency)}}{{jobPost?.salaryFrom | salary}} - 
                                  {{getCurrencySymbol(jobPost?.salaryCurrency)}}{{jobPost?.salaryTo | salary}}</strong>
                                </p>
                            </div>
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-degree.svg" alt="Degree"></div>
                                <p>Degree<br><strong>{{jobPost?.degreeLevel}}</strong></p>
                            </div>
                        </div>
                        <div class="job-categories-section">
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-speciality.svg" alt="Speciality">
                                </div>
                                <p>Speciality<br><strong>{{jobPost?.speciality}}</strong></p>
                            </div>
                            <div class="mb-4">
                                <div class="icon"><img src="/assets/images/careers-job-positions.svg" alt="Positions">
                                </div>
                                <p>Positions<br><strong>{{jobPost?.totalPositions}}</strong></p>
                            </div>
                        </div>
                        <div class="skills mt-3 mb-2">Skills Required</div>
                        <mat-chip class="skills-chip" *ngFor="let skill of jobPost.skills; let i = index"
                            class="me-2 mb-2">{{skill}}</mat-chip>
                        <div class="skills mt-3 mb-2">Tags</div>
                        <mat-chip class="tags-chip" *ngFor="let tag of jobPost.tags; let i = index"
                            class="me-2 mb-2">{{tag}}</mat-chip>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="share-popup" *ngIf="showSharePopup">
        <div class="share-popup-content">
            <span class="close-icon" (click)="closeSharePopup()">&times;</span>
            <h2 class="sharePopup-heading">Share Job</h2>
            <div class="input-group">
                <input type="text" class="form-control shareLink-input" [value]="currentUrl" readonly>
                <button class="btn btn-primary linkCopyBtn" (click)="copyUrl()">Copy Link</button>
            </div>
        </div>
    </div>
</div>
<app-website-footer></app-website-footer>